module.exports = __webpack_public_path__ + "img/bot-left-bg.7eb1b211.png";